import { Injectable } from '@angular/core';
import { RewardsPreferenceResponse } from '@features/rewards-preference/models/rewards-preference.response';
import {
  RewardsPreference,
  RewardsPreferenceType,
} from '@features/rewards-preference/types/rewards-preference.type';
import { NydusNetworkApiDataService } from '@rd/core/services/nydus-network-api-data/nydus-network-api-data.service';
import { MembershipType } from '@rd/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RewardsPreferenceApiService {
  constructor(private nydusNetworkDataService: NydusNetworkApiDataService) {}

  createRewardsPreference(body: {
    rewardsPreference: RewardsPreferenceType;
    membership:
      | {
          loyaltyProgramId: string;
          number: string;
          firstName: string;
          lastName: string;
        }
      | {
          membershipId: string;
          number: string;
          firstName: string;
          lastName: string;
        };
  }): Observable<RewardsPreference> {
    return this.nydusNetworkDataService
      .post<RewardsPreferenceResponse>('reward_preference', {
        membership: body.membership,
        rewardPreference: {
          rewardType: body.rewardsPreference,
          data: {},
        },
      })
      .pipe(
        map((response) => this.transformRewardsPreferenceResponse(response)),
      );
  }

  getRewardsPreference(): Observable<RewardsPreference> {
    return this.nydusNetworkDataService
      .get<RewardsPreferenceResponse>('reward_preference')
      .pipe(
        map((response) => this.transformRewardsPreferenceResponse(response)),
      );
  }

  private transformRewardsPreferenceResponse(
    response: RewardsPreferenceResponse,
  ): RewardsPreference {
    const membershipModel = response.included[0];
    const { attributes } = membershipModel;

    return {
      id: response.data.id,
      rewardType: response.data.attributes.rewardType,
      membership: {
        id: membershipModel.id,
        type: MembershipType.PointsTransfer,
        category: attributes.category,
        firstName: attributes.firstName ?? '',
        lastName: attributes.lastName ?? '',
        loyaltyProgramId: attributes.loyaltyProgramId,
        loyaltyProgramName: attributes.loyaltyProgramName,
        number: attributes.number,
        preferred: attributes.preferred,
        userId: attributes.userId,
      },
    };
  }
}
